// index.tsx
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
// @ts-ignore
//import * as serviceWorkerRegistration from './serviceWorkerRegistration'; // Ignora la verificación de tipos

const siteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY as string;

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <GoogleReCaptchaProvider reCaptchaKey={siteKey}>
    <App />
  </GoogleReCaptchaProvider>
);

// Registro del service worker
// serviceWorkerRegistration.register();
